import { Component, HostListener, OnInit } from '@angular/core';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FeatureGroupTemplateModalComponent } from '../feature-group-template-modal/feature-group-template-modal.component';
import { FeatureGroupTemplateService } from '../../services/feature-group-template.service';
import { LoaderService } from '@app-shared/services/loader.service';
import { AlertService } from '@main/alert.service';
import { Router } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';
import {
  faPencil,
  faPlus,
  faRotateRight,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { ConfirmationModalComponent } from '@main/confirmation-modal/confirmation-modal.component';
import { NgIf, NgFor } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-group-template',
    templateUrl: './group-template.component.html',
    styleUrls: ['./group-template.component.css'],
    imports: [
        FaIconComponent,
        NgbTooltip,
        NgIf,
        NgFor
    ]
})
export class GroupTemplateComponent implements OnInit {
  //Screensize event Listener
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.resizeSubject.next((event.target as Window).innerWidth);
  }

  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {
    event.preventDefault();
    if (this.modalService || this.modalService.hasOpenModals()) {
      this.modalCreateProposalRef?.close();
      this.modalDeleteProposalRef?.close();
    }
  }

  // Variable Subject
  private resizeSubject: Subject<number> = new Subject<number>();

  faPlus = faPlus;
  faRotateRight = faRotateRight;
  templateProposals: any[] = [];
  isRefreshing: boolean;
  isMobileView: boolean = false;
  selectedGroupTemplate: any = null;
  faTrash = faTrash;
  faPencil = faPencil;

  modalCreateProposalRef: any;
  modalDeleteProposalRef: any;

  constructor(
    private modalService: NgbModal,
    private featureGroupTemplateService: FeatureGroupTemplateService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private router: Router,
  ) {
    this.resizeSubject.pipe(debounceTime(100)).subscribe((width) => {
      if (width <= 768) {
        this.checkScreenSize(width);
      } else {
        this.isMobileView = false;
      }
    });
  }

  ngOnInit(): void {
    this.checkScreenSize();
    this.getProposalTemplate();
  }

  // Get isMobile value in reactive way
  public get isMobile(): boolean {
    return this.isMobileView;
  }

  getProposalTemplate() {
    this.isRefreshing = true;
    //this.templateProposals = [];
    this.featureGroupTemplateService
      .getProposalTemplates()
      .subscribe((data: any) => {
        this.templateProposals = data;
        this.isRefreshing = false;
      });
  }

  createProposalTemplate() {
    this.modalCreateProposalRef = this.modalService.open(FeatureGroupTemplateModalComponent);

    this.modalCreateProposalRef.componentInstance.save.subscribe((data: any) => {
      this.saveProposalTemplate(data);
    });
  }

  deleteProposalTemplate(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.selectedGroupTemplate = data;
    this.modalDeleteProposalRef = this.modalService.open(ConfirmationModalComponent);
    this.modalDeleteProposalRef.componentInstance.message = `Are you sure you want to delete this template <b>${data?.groupTemplateName}</b>?`;
    this.modalDeleteProposalRef.componentInstance.actionBtnTitle = 'Delete';

    this.modalDeleteProposalRef.componentInstance.confirmed.subscribe((data: any) => {
      this.deleteGroupTemplate();
    });
  }

  saveProposalTemplate(data: any) {
    this.loaderService.showSpinner();
    this.featureGroupTemplateService
      .createProposalTemplate({ groupTemplateName: data.groupTemplateName })
      .subscribe((data: any) => {
        this.alertService.showSuccessAlert(
          `Successfully created proposal template!`
        );
        this.getProposalTemplate();
        this.loaderService.hideSpinner();

        this.router.navigate([`/templates/feature-group-template/${data}`]);
      });
  }

  deleteGroupTemplate() {
    this.loaderService.showSpinner();
    this.featureGroupTemplateService
      .deleteGroupTemplate(this.selectedGroupTemplate)
      .subscribe((data: any) => {
        this.getProposalTemplate();
        this.alertService.showSuccessAlert(
          `Successfully deleted proposal template!`
        );
        this.loaderService.hideSpinner();
      });
  }

  editTemplateProposal(data: any) {
    this.router.navigate([`/templates/feature-group-template/${data.groupTemplateId}`]);
  }

  //Set isMobile value and set table limit base on screen size
  checkScreenSize(width?: number) {
    let screenWidth = width || window.innerWidth;
    this.isMobileView = screenWidth <= 768;
  }
}
